import { useLayoutEffect, useState } from 'react';

type UsePeekItemParams = {
	peekMenuId?: string;
};

export const usePeekItem = ({ peekMenuId }: UsePeekItemParams) => {
	const [peekedItemIdActual, setPeekedItemId] = useState<string | null | undefined>(null);

	/**
	 * We always change the peeked item ID on change (which can happen from multiple sources, that's why this hook exists), because
	 * a) there is logic in the GlobalSideNavContent where this is used, which determines
	 *    whether to render or not using information that component is already aware of
	 * b) apps are responsible for validating their own item IDs; if they pass one in that isn't currently in the menu,
	 * 	  it won't be displayed in GlobalSideNavContent anyway, which has the same effect as us checking and clearing the state but with less code
	 */
	useLayoutEffect(() => {
		setPeekedItemId(peekMenuId);
	}, [peekMenuId]);

	return {
		peekedItemIdActual,
		setPeekedItemId,
	};
};
